import { PrimitiveAtom, useAtom } from 'jotai'

import { selectedDetailsItemAtom, showDetailsDrawerAtom } from '@/store/tasksApprovals/detailsDrawer'
import { ICompliance } from '@/types/tasksApprovals'

import SystemIcon from '../../systemIcon'
import Task from './Task'

const Container = ({ item, isLastItem = false }: { item: ICompliance; isLastItem?: boolean }) => {
    const [, showDetaislDrawer] = useAtom<PrimitiveAtom<boolean>>(showDetailsDrawerAtom)
    const [, setDetailsItem] = useAtom(selectedDetailsItemAtom)

    const onClick = () => {
        setDetailsItem(item)
        showDetaislDrawer(true)
    }

    return (
        <>
            <Task item={item} icon={<SystemIcon system={item.system_id} />} onClick={onClick} isLastItem={isLastItem} />
        </>
    )
}

export default Container
